// import store from '@/store';
// import moment from "moment";
import consts from "@/consts";

const defaultSetRoute = {}

const routes = (process.env.VUE_APP_PACKAGE !== 'prometheus.portal') ? [] : [
    {
        path: 'orchestrator/:pathMatch(.*)?',
        name: consts.routerNames.orchestrator.main,
        meta: {
            //list: '',
            mainRouteName: consts.routerNames.orchestrator.main,
            showMap: false,
            layers: consts.defaultSettingsLayers,
            setRoute: defaultSetRoute,
        },
        component: () => import('@/views/prometheus/portal/OrchestratorPage.vue')
    },
];

export default routes;